import type { ActionSpec } from '@/pages/aiagent/actions';

/**
 * 쓰기 승낙 줄 — <b>「지금 등록해 드릴까요?」의 답</b> (사용자 지시 2026-09-11).
 *
 * <h2>카드가 아니다</h2>
 *
 * 예전에는 요약 표와 제목이 붙은 확인 카드가 떴고, 그 카드를 건너뛰는 「확인 없이 실행」 스위치가
 * 제목 줄에 따로 있었다. 둘 다 없앴다. <b>무엇을 저장할지는 에이전트가 문장으로 말했다</b> —
 * 같은 값을 표로 한 번 더 그리면 사용자는 같은 것을 두 번 읽고, 스위치는 「지금 켜져 있는가」를
 * 늘 신경 쓰게 만들었다. 여기 남는 것은 <b>대답 두 개</b>뿐이다.
 *
 * <h2>버튼이 유일한 길은 아니다</h2>
 *
 * 손으로 「네」라고 적어도 같은 자리로 들어온다({@link AgentChatProvider} §승낙). 버튼은 손이 덜
 * 가게 할 뿐이라, 이 줄을 그리지 못하는 곳에서도 대화는 성립한다 — 되물음 칩과 같은 규율이다
 * ({@link ChoiceCard}).
 *
 * <h2>「아니요」를 감추지 않는다</h2>
 *
 * 거절은 <b>아무 일도 일어나지 않는 쪽</b>이라 조용한 모양이지만, 자리는 같다. 답이 하나뿐인
 * 물음은 물음이 아니다.
 */
export function ConfirmRow({
  spec,
  pending,
  onYes,
  onNo,
  compact = false,
}: {
  spec: ActionSpec;
  /** 실행이 나가 있는 동안. 두 번 눌리면 두 건이 저장된다. */
  pending: boolean;
  onYes: () => void;
  onNo: () => void;
  compact?: boolean;
}) {
  const size = compact ? 'px-2.5 py-1.5 text-xs' : 'px-3 py-1.5 text-sm';

  return (
    <div className="flex flex-wrap gap-1.5">
      <button
        type="button"
        onClick={onYes}
        disabled={pending}
        className={`rounded-lg font-medium disabled:opacity-60 ${size}`}
        style={{ background: 'var(--accent)', color: '#ffffff', border: '1px solid var(--accent)' }}
      >
        {pending ? '처리 중…' : spec.confirmLabel}
      </button>
      <button
        type="button"
        onClick={onNo}
        disabled={pending}
        className={`rounded-lg font-medium bg-white hover:bg-slate-50 disabled:opacity-60 ${size}`}
        style={{ border: '1px solid var(--border)', color: 'var(--text-secondary)' }}
      >
        아니요
      </button>
    </div>
  );
}
